import { VehicleDamageMeta, VehicleDamageMetaContainer } from '@app/shared/models/vehicle-damage-meta';
import * as _ from 'lodash-es';
import { OP, OpData } from '@app/core/services/base/base-service-with-bundle.service';
import { Area } from '@app/shared/models/area';
import { Damage } from '@app/shared/models/damage';

export class DamageAreaSelector {
    public areas: Area[];
    public vehicleDamageMetaList: VehicleDamageMetaContainer[];
    public selectedVehicleMeta: VehicleDamageMeta;

    constructor(areas: Area[]) {
        this.areas = areas;
    }

    public getAreaByCode(code: string): Area {
        return this.areas.find(a => a.code === code);
    }

    public setSelectedVehicle(vehicleCode: string): void {
        this.selectedVehicleMeta = this.getVehicleByGraphicKey(vehicleCode);
    }

    public toggleAreaSelected(areaCode: string): boolean {
        const area = this.getAreaByCode(areaCode);
        area.selected = !area.selected;
        return area.selected;
    }

    public selectAllAreas(): void {
        _.forEach(this.areas, (area) => {
            area.selected = true;
        });
    }

    public unselectAllAreas(): void {
        _.forEach(this.areas, (area) => {
            area.selected = false;
        });
    }

    public toggleAllAreasSelected(value: boolean): OpData[] {
        if (value) {
            this.selectAllAreas();
        } else {
            this.unselectAllAreas();
        }

        return this.areas.map(area => {
            return {
                op: OP.replace,
                path: `vehicle/damage/${area.code}`,
                value: area.selected
            };
        });
    }

    public getSelectedAreas(): Area[] {
        return this.areas.filter(area => area.selected);
    }

    public setSelectedAreas(damage: Damage): void {
        _.forEach(this.areas, (area) => {
            area.selected = damage[area.code];
        });
    }

    public allAreasSelected(): boolean {
        return _.every(this.areas, area => area.selected);
    }

    public getVehicleByGraphicKey(key: string): VehicleDamageMeta {
        let found = null;

        this.vehicleDamageMetaList.forEach(group => group.meta.forEach(meta => {
            if (meta.graphic_key === key) {
                found = meta;
            }
        }));

        return found;
    }

    public add(vehicleDamageMetaContainer: VehicleDamageMetaContainer): void {
        if (!this.vehicleDamageMetaList) {
            this.vehicleDamageMetaList = new Array<VehicleDamageMetaContainer>();
        }
        this.vehicleDamageMetaList.push(vehicleDamageMetaContainer);
    }

    public sortVehicleDamageMeta(): void {
        this.vehicleDamageMetaList.forEach(group => {
            group.meta = _.sortBy(group.meta, (meta) => meta.graphic_key_translated);
        });
    }
}
